import { useState } from "react";
import pressArticles from "./pressArticles";
import "./press.css";

// Articles shown in the grid before "Show all coverage".
const GRID_INITIAL = 6;

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// "2026-09-29" -> "Sep 29, 2026"; "2023-04" -> "Apr 2023"
const formatDate = (date) => {
  const [year, month, day] = date.split("-").map(Number);
  return day
    ? `${MONTHS[month - 1]} ${day}, ${year}`
    : `${MONTHS[month - 1]} ${year}`;
};

// Stable sort, so same-day entries keep their order from pressArticles.js.
const articles = [...pressArticles].sort((a, b) => b.date.localeCompare(a.date));

const CardLink = ({ article, className, children }) =>
  article.url ? (
    <a className={className} href={article.url} target="_blank" rel="noreferrer">
      {children}
    </a>
  ) : (
    <div className={className}>{children}</div>
  );

const Thumb = ({ article, lazy }) => (
  <div className={`press-thumb${article.legacy ? " press-thumb--legacy" : ""}`}>
    <img src={article.image} alt="" loading={lazy ? "lazy" : undefined} />
  </div>
);

const Meta = ({ article }) => (
  <div className="press-meta">
    <span className="press-outlet">{article.outlet}</span>
    <span className="press-dot">·</span>
    <time dateTime={article.date}>{formatDate(article.date)}</time>
  </div>
);

const Press = () => {
  const [expanded, setExpanded] = useState(false);
  const [featured, ...rest] = articles;
  const visible = expanded ? rest : rest.slice(0, GRID_INITIAL);
  const hiddenCount = rest.length - visible.length;

  return (
    <div className="press">
      <CardLink article={featured} className="press-featured">
        <Thumb article={featured} />
        <div className="press-featured-body">
          <div className="press-eyebrow">Latest</div>
          <Meta article={featured} />
          <h3 className="press-featured-title">{featured.title}</h3>
          {featured.summary && (
            <p className="press-summary">{featured.summary}</p>
          )}
          {featured.url && (
            <span className="press-read">
              Read the article{" "}
              <svg className="press-read-arrow" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M4 12h15m-6-6 6 6-6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          )}
        </div>
      </CardLink>

      <div className="press-grid">
        {visible.map((article) => (
          <CardLink
            key={article.url || article.image}
            article={article}
            className="press-card"
          >
            <Thumb article={article} lazy />
            <div className="press-card-body">
              <Meta article={article} />
              <h4 className="press-card-title">{article.title}</h4>
            </div>
          </CardLink>
        ))}
      </div>

      {hiddenCount > 0 && (
        <button className="press-more" onClick={() => setExpanded(true)}>
          Show all coverage ({hiddenCount} more)
        </button>
      )}
    </div>
  );
};

export default Press;
